import { render, staticRenderFns } from "./SearchAforoModal.vue?vue&type=template&id=e5a03c20"
import script from "./SearchAforoModal.vue?vue&type=script&lang=js"
export * from "./SearchAforoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports